import urlUtils from './urlUtils';
import type { ScreenPopRequest } from '../Containers/ScreenPop/ScreenPop.types';

// Marks a return from the automatic Google sign-in. Coming back still signed out with it set means
// the sign-in failed, so the page stops instead of redirecting to Google again in a loop.
export const LOGIN_ATTEMPTED_PARAM = 'loginAttempted';

// Any regional app host (app, app-eu1, app-na2, …), so changing AppBaseUrl in AppConfig needs no frontend deploy.
const HUBSPOT_APP_HOST = /^app(-[a-z0-9]+)?\.hubspot\.com$/;

// Parameter names as Puzzel's CRM Pop sends them on the /hs-screenpop URL.
export const toScreenPopRequest = (search: string): ScreenPopRequest => {
    const params = new URLSearchParams(search);
    return {
        accountNumber: params.get('accountNumber'),
        queueKey: params.get('queueKey'),
        puzzelSessionId: params.get('puzzel_session_id'),
        puzzelCallId: params.get('puzzel_call_id'),
        puzzelUserId: params.get('puzzel_user_id'),
        phoneNumber: params.get('phoneNumber'),
    };
};

export const hasAttemptedLogin = (search: string): boolean => new URLSearchParams(search).get(LOGIN_ATTEMPTED_PARAM) === '1';

export const buildScreenPopLoginUrl = (apiHostname: string, pathname: string, search: string): string => {
    const params = new URLSearchParams(search);
    params.set(LOGIN_ATTEMPTED_PARAM, '1');
    const returnPath = `${pathname}?${params.toString()}`;
    return `${apiHostname}/api/auth/login?returnPath=${encodeURIComponent(returnPath)}`;
};

export const toHubSpotRedirect = (url: string | null | undefined): string | null => {
    if (url === null || url === undefined) return null;
    const safe = urlUtils.toSafeHttpUrl(url);
    if (safe === null) return null;
    const parsed = new URL(safe);
    return parsed.protocol === 'https:' && HUBSPOT_APP_HOST.test(parsed.host) ? safe : null;
};
